import { 
	ensureCameraAction, 
	ensureVoiceOverAttribute, 
	fixGrapesComponentIDs, 
	removeSpecialNodeStyling, 
	removeCssProperties, 
	replaceCssClassesWithExplicitStyles, 
	replaceGrapesTextComponents, 
	upgradeGrapesPositionFormat, 
	fixGrapesPreviewUrls
} from "./GrapesJSUtilities";
import { GjsComponentTypes } from "./gjsplugin/Enums";
import { CssProperties, IGrapesJSProjectData } from "../../interfaces/VisageUI";

/**
 * Upgrades the GrapesJS project data to the latest format version
 * The update is done in-place, so make sure to pass in a writable object!
 *
 * @export
 * @param {IGrapesJSProjectData} grapesProject
 */
export function upgradeGrapesProject(grapesProject: IGrapesJSProjectData): void
{
	fixGrapesComponentIDs(grapesProject);
	fixGrapesPreviewUrls(grapesProject);
	replaceGrapesTextComponents(grapesProject);
	upgradeGrapesPositionFormat(grapesProject);
	replaceCssClassesWithExplicitStyles(grapesProject);
	ensureVoiceOverAttribute(grapesProject);
	
	const propertiesToRemove = [
		{
			type: GjsComponentTypes.Text,
			properties: [
				CssProperties.BorderColor,
				CssProperties.BorderStyle,
				CssProperties.BorderWidth,
				CssProperties.BoxShadow,
			]
		}
	];
	removeCssProperties(grapesProject, propertiesToRemove);

	ensureCameraAction(grapesProject);
	removeSpecialNodeStyling(grapesProject);
}